var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "mb-0", class: _vm.name, attrs: { id: _vm.name } },
    [
      _c(
        "section-error",
        {
          staticClass: "form-container fe-radio-form large-radio px-0",
          class: _vm.horizontalStyle
            ? "horizontal-options"
            : ((_obj = { "w-100": _vm.fullWidth }),
              (_obj[_vm.containerClass] = true),
              _obj),
          style: _vm.horizontalStyle
            ? {
                display: "flex",
                "flex-direction": "row",
                "justify-content": "space-between",
              }
            : {},
          attrs: {
            tag: "div",
            icon: false,
            "data-options-count": _vm.options.length,
          },
        },
        [
          _vm._l(_vm.options, function (option) {
            var _obj
            return _c(
              "div",
              {
                key: _vm.radioId(option.value),
                staticClass: "fe-option col-xs-12",
                class:
                  ((_obj = { "h-100 my-2": option.description }),
                  (_obj[_vm.optionClass] = true),
                  _obj),
              },
              [
                _c("input", {
                  class: _vm.className,
                  attrs: {
                    id: _vm.radioId(option.value),
                    disabled: _vm.disabled,
                    type: "radio",
                    name: _vm.inputName,
                    tabindex: _vm.tabindex,
                  },
                  domProps: {
                    checked: _vm.checked === option.value,
                    value: option.value,
                  },
                  on: { change: _vm.handleInput, click: _vm.handleClick },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "checkmark",
                  class: { "no-identation": _vm.noIdentation },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    class: {
                      "py-2": option.description,
                      "no-identation": _vm.noIdentation,
                    },
                    attrs: {
                      for:
                        "" +
                        (_vm.labelFromName
                          ? _vm.inputName
                          : _vm.radioId(option.value)),
                    },
                  },
                  [
                    option.description
                      ? _c("div", [
                          _c("p", { staticClass: "bold mb-0" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("getSchemaTranslation")(
                                    option.label,
                                    _vm.translationMap
                                  )
                                ) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(option.description) +
                                "\n          "
                            ),
                          ]),
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("getSchemaTranslation")(
                                  option.label,
                                  _vm.translationMap
                                )
                              ) +
                              "\n        "
                          ),
                        ]),
                  ]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c("section-error", { attrs: { "error-message": _vm.errorMessage } }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }